import { render, staticRenderFns } from "./sampleTestingSchedule.vue?vue&type=template&id=2d610d8b"
import script from "./sampleTestingSchedule.ts?vue&type=script&lang=js&external"
export * from "./sampleTestingSchedule.ts?vue&type=script&lang=js&external"
import style0 from "./sampleTestingSchedule.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports